import * as React from 'react';
import Form from '../../Form';
import { FormControl } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import FormHelperText from '@mui/material/FormHelperText';

interface BillingSettingsProps {
  paymentTerm: string;
  paymentTermKey: string;
  onFieldChange(event);
}

class BillingSettings extends Form<BillingSettingsProps, any> {
  public render() {
    const { paymentTerm, paymentTermKey, onFieldChange, formErrors, disableForm } = this.props;
    return (
      <fieldset>
        <legend>Billing Settings</legend>
        <FormControl variant="standard" disabled={disableForm}>
          <InputLabel htmlFor="payment-term">Payment Term</InputLabel>
          <Input
            id="payment-term"
            name={paymentTermKey}
            value={paymentTerm}
            onChange={onFieldChange}
            type="number"
            inputProps={{ min: 0, step: 1 }}
          />
          <FormHelperText>
            If payment term field is not empty, it will override the company payment term value
          </FormHelperText>
          {formErrors.payment_term && <FormHelperText error={true}>{formErrors.payment_term}</FormHelperText>}
        </FormControl>
      </fieldset>
    );
  }
}

export default BillingSettings;
